import styled from 'styled-components';
import { WHITE, PALE_WHITE_6 } from '../../appearance/Colors';

export const Page = styled.div`
    display: flex;
    flex: 1 1 auto;
    min-height: 0;
    width: 100%;
    margin: 0;
    padding: 14px 8px 18px 20px;
    box-sizing: border-box;
    color: ${WHITE};
    gap: 14px;

    @media (max-width: 860px) {
        padding: 10px 12px 12px;
    }
`;

export const MainColumn = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-width: 0;
    min-height: 0;
    padding-right: 6px;
`;

export const ContentPane = styled.div`
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: ${({ $isGrid }) => ($isGrid ? 'stretch' : 'center')};
`;

export const HeaderBar = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    min-width: 0;

    @media (max-width: 620px) {
        align-items: flex-start;
        flex-direction: column;
        gap: 8px;
    }
`;

export const TitleGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;

    h1 {
        font-size: 17px;
        line-height: 1.25;
        margin: 0;
        color: ${WHITE};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
`;

export const ViewToggle = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 2px;
    padding: 3px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.04);
    flex: 0 0 auto;

    @media (max-width: 620px) {
        display: none;
    }
`;

export const ViewButton = styled.button`
    width: 30px;
    height: 30px;
    border: 0;
    border-radius: 6px;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: ${({ $active }) => ($active ? WHITE : 'rgba(255, 255, 255, 0.58)')};
    background: ${({ $active }) => ($active ? 'rgba(255, 255, 255, 0.14)' : 'transparent')};
    cursor: pointer;

    &:hover {
        color: ${WHITE};
        background: rgba(255, 255, 255, 0.1);
    }
`;

export const StateMessage = styled.div`
    color: ${PALE_WHITE_6};
    text-align: center;
    padding: 80px 0;
`;

export const GridScroll = styled.div`
    flex: 1 1 auto;
    min-height: 0;
    width: 100%;
    overflow-y: auto;
    padding-bottom: 12px;
`;
